
const digest = '9ad32065c35f4186813d3eb21d700d25ddfeea90818410451047ece8255e3960';
const classes = {"wrapper":"_wrapper_82abr_1","controls":"_controls_82abr_11"};
const css = `._wrapper_82abr_1 {
  font-family: Rubik, "sans-serif";
  border: 1px solid #eaedf3;
  flex-direction: column;
  height: 100%;
  overflow-y: scroll;
  -ms-overflow-style: auto;
  scrollbar-width: 3px;
  background: #ffffff;
}
._wrapper_82abr_1 ._controls_82abr_11 {
  padding: 24px;
  margin-top: 20px;
  display: flex;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  